// components/Map/MapV3.jsx

import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import { getOrDeleteRequest } from "../../utils/utils";
import { customIcon } from "../../data/dataCustomMapStyles";

// Corregir problema de iconos de Leaflet en entornos de empaquetado (Vite/Webpack)
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

export default function Map({ 
    project_id, 
    company_id, 
    company_type_id, 
    sector_id, 
    state_id, 
    city_id, 
    district_id 
}) {
    const [markers, setMarkers] = useState([]);

    const getUbications = async () => {
        try {
            let url = 'dashboard/companies-map-data';
            const params = new URLSearchParams();

            if (state_id) params.append('state_id', state_id);
            if (city_id) params.append('city_id', city_id);
            if (district_id) params.append('district_id', district_id);

            // Filtros externos
            if (project_id) params.append('project_id', project_id);
            if (company_id) params.append('company_id', company_id);
            if (company_type_id) params.append('company_type_id', company_type_id);
            if (sector_id) params.append('sector_id', sector_id);

            if (params.toString()) url += `?${params.toString()}`;

            const response = await getOrDeleteRequest(url, 'GET');
            
            if (response.data && response.data.length > 0) {
                const mappedMarkers = response.data
                    .map((organization) => ({
                        id: organization.id,
                        position: [organization.latitude, organization.longitude],
                        company_name: organization.company_name,
                    }))
                    .filter((marker) => 
                        marker.position[0] !== null && 
                        marker.position[1] !== null &&
                        !isNaN(marker.position[0]) &&
                        !isNaN(marker.position[1])
                    );
                setMarkers(mappedMarkers);
            } else {
                setMarkers([]);
            }
        } catch (error) {
            console.error("Error fetching locations", error);
        }
    };

    useEffect(() => {
        getUbications();
    }, [project_id, company_id, company_type_id, sector_id, state_id, city_id, district_id]);

    return (
        <div className="h-[370px] w-full flex flex-col">
            <div className="h-full w-full">
                <MapContainer
                    center={[13.6984, -89.0114]}
                    zoom={8}
                    className="h-full w-full"
                    scrollWheelZoom={false}
                >
                    <TileLayer
                        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                        attribution='&copy; <a href="https://carto.com/">CARTO</a> contributors'
                    />

                    {markers.map((marker) => (
                        <Marker key={marker.id} position={marker.position} icon={customIcon}>
                            <Popup>
                                {marker.company_name}
                            </Popup>
                        </Marker>
                    ))}
                </MapContainer>
            </div>
        </div>
    );
}